var _IconMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { IconAlertCritical, IconAlertInformational, IconAlertSuccess, IconAlertWarning } from '@airwallex/glyphs';
import React from 'react';
import { AlertVariants } from '../types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var IconMap = (_IconMap = {}, _defineProperty(_IconMap, AlertVariants.INFORMATIONAL, IconAlertInformational), _defineProperty(_IconMap, AlertVariants.SUCCESS, IconAlertSuccess), _defineProperty(_IconMap, AlertVariants.WARNING, IconAlertWarning), _defineProperty(_IconMap, AlertVariants.CRITICAL, IconAlertCritical), _IconMap); //test

function determineIcon(_ref) {
  var variant = _ref.variant;
  if (variant) return IconMap[variant];
  return IconMap.SUCCESS;
}

var Icon = function Icon(_ref2) {
  var variant = _ref2.variant;
  var VariantIcon = determineIcon({
    variant: variant
  });
  return ___EmotionJSX(VariantIcon, {
    size: 24
  });
};

export default Icon;